import React, { useState } from "react";
import InsightCardsOptions from "./InsightCardsOptions";
import allImgPaths from "assets/images";
import { Modal } from "components/common/modal/Modal";
import { HeaderModal } from "components/common/modal/Header";
import { Body } from "components/common/modal/Body";
import DonutChart2 from "components/common/charts/DonutChart2";

const Response = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [openMaximizeModal, setOpenMaximizeModal] = useState(false);

  const MaximizeModal = () => {
    return (
      <Modal className={"modal-wrapper max-w-[350px]"} isShow={openMaximizeModal}>
	  <img
            className="cursor-pointer absolute top-3 right-3"
            id="modal-toggle"
            src={allImgPaths.closeIcon}
            onClick={() => setOpenMaximizeModal(false)}
            alt="close icon"
          />
        <Body title="header" isShowBody={true} className="">
          <div className="bg-[#fff] rounded-xl px-6 py-6">
            {/* Heading */}
            <div className="flex items-center justify-between mb-5 w-full">
              <h4 className="text-base font-interSemiBold text-[#101828]">Responses</h4>
            </div>

            <div className="response-chart">
              <DonutChart2
                showLegends={true}
                colors={["#F79009", "#F04438", "#17B26A", "#D0D5DD"]}
                series={[44, 89, 53, 103]}
                />
            </div>
          </div>
          
        </Body>
      </Modal>
    );
  };
  return (
    <>
      <div className="bg-[#fff] rounded-xl border border-[#EAECF0] px-6 py-6 w-[360px]">
        {/* Heading */}
        <div className="flex items-center justify-between mb-5 w-full">
          <h4 className="text-base font-interSemiBold text-[#101828]">Responses</h4>
          <div
            className='p-1 cursor-pointer relative hover:bg-[#f2f4f7] rounded w-5 focus-within:bg-[#f2f4f7]'
            onClick={() => setShowOptions(!showOptions)}
          >
            <img className="mx-auto" src={allImgPaths.threeVerticleDotsIcon} alt="three dots" />
            <InsightCardsOptions
              isShow={showOptions}
              openMaximizeModal={() => setOpenMaximizeModal(true)}
              chartName = 'donut_chart_2'
              downloadChartName = 'attendee_responses'
            />
          </div>
        </div>

        <div className="response-chart">
          <DonutChart2
            showLegends={true}
            colors={["#F79009", "#F04438", "#17B26A", "#D0D5DD"]}
            series={[44, 89, 53, 103]}
          />
        </div>
      </div>
      <MaximizeModal />
    </>
  );
};

export default Response;
